import { SeriesRequestPayload } from '../../../../../types/bookingCreation';
import { attributionPayload } from '../../../../../utils/costCenter';
import { ServerSeriesPattern } from '../../../../../utils/recurrence';

/**
 * What both series screens (the create wizard and the extend panel) send to
 * the series routes: the booking fields under the single-booking form's
 * names, and the pattern. One builder, so the two screens cannot send the same
 * series differently — in particular both name the OFFER (`groupId`, #2650),
 * which is what the series routes book.
 */
export interface SeriesBookingFields {
    groupId: string;
    startTime: string;
    endTime: string;
    customerDetails: SeriesRequestPayload['customerDetails'];
    numberOfGuests: number;
    eventType: string | null;
    comment: string;
    additionalServices: { serviceId: string, quantity: number }[];
    /**
     * #1810: who the series is booked for and the invoice recipient's cost
     * centre — every occurrence carries the same. Absent = none sent, which
     * the series routes read as "no attribution".
     */
    attribution?: { organizationId: string | null, organizationUnitId: string | null, costCenter: string };
}

export const seriesRequestFrom = (fields: SeriesBookingFields, pattern: ServerSeriesPattern): SeriesRequestPayload => ({
    pattern,
    startTime: fields.startTime,
    endTime: fields.endTime,
    groupId: fields.groupId,
    customerDetails: fields.customerDetails,
    numberOfGuests: fields.numberOfGuests,
    eventType: fields.eventType || null,
    comment: fields.comment,
    additionalServices: fields.additionalServices.map((s) => ({ serviceId: s.serviceId, quantity: s.quantity })),
    ...(fields.attribution ? attributionPayload(fields.attribution) : {}),
});

/** A single date as a pattern — for adding one removed date after all. */
export const singleDatePattern = (date: string): ServerSeriesPattern => ({
    type: 'custom',
    startDate: date,
    customDates: [date],
    endCondition: { occurrences: 1 },
});
